import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutThirdFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-third-full"} maskId="square-filled-radius-0-stroke-1-IconLayoutThirdFull"><path d="M3 3V8.25L21 8.25V3H3Z" fill="currentColor"/><path d="M3 14.75V9.25L21 9.25V14.75L3 14.75Z" fill="currentColor"/><path d="M3 15.75V21H21V15.75L3 15.75Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutThirdFull;
